export default "__VITE_ASSET__8ppbkTBo__ 640w, __VITE_ASSET__BMtkyZxC__ 1024w, __VITE_ASSET__CouKNZvz__ 1376w";